<template>

    <div class="step-content">
        <div class="intro-block">
            <h5 class="txt-grt">Business models</h5>
            <p>Define your business models. You can pick and choose the best monetization for your community.</p>
        </div>
        <div class="step-inner-content">

            <SelectWrapper item="Subscription" caption="Create your own SVOD platform" v-model="Global.mockupConfig.business.subscription"></SelectWrapper>
            <SelectWrapper item="Transactional" caption="Build your video rental shop" v-model="Global.mockupConfig.business.transactional"></SelectWrapper>
            <SelectWrapper item="Pay per View" caption="Open access to your platform for events" v-model="Global.mockupConfig.business.payPerView"></SelectWrapper>
            <SelectWrapper item="Advertising" caption="Monetize your content through ads" v-model="Global.mockupConfig.business.advertising"></SelectWrapper>
            <SelectWrapper item="Free" caption="Provide free content to end users" v-model="Global.mockupConfig.business.free"></SelectWrapper>

            <div class="nxt-out">
                <div class="bgout"></div>
                <router-link tag="div" to="/content" class="btn bck">
                    <span class="txt">Back</span>
                </router-link>
                <router-link tag="div" to="/look" class="btn main txt-blk">
                    <span class="hvr"></span>
                    <span class="txt">Continue</span>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import SelectWrapper from '../../components/SelectWrapper'

    export default {

        name: 'C',

        components: {
            SelectWrapper
        },

        data() {
            return {
                Global
            }
        }
    }
</script>